import type {
  ReadingStateRecord,
  ReadingStateRepository,
} from "@/domain";

import type { DatabaseInvalidationPublisher } from "./broadcast-channel";
import type { MarginaliaDatabase } from "./database";
import { toStorageWriteError } from "./storage-errors";

export class DexieReadingStateRepository implements ReadingStateRepository {
  constructor(
    private readonly db: MarginaliaDatabase,
    private readonly invalidation?: DatabaseInvalidationPublisher,
  ) {}

  get(documentId: string): Promise<ReadingStateRecord | undefined> {
    return this.db.readingStates.get(documentId);
  }

  async put(record: ReadingStateRecord): Promise<void> {
    try {
      await this.db.readingStates.put(record);
    } catch (error) {
      throw toStorageWriteError(error, "save reading position");
    }

    this.invalidation?.publish({
      type: "document-changed",
      documentId: record.documentId,
    });
  }
}
